"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Marks the end of the course.
 */
class EndCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.End);
    }
    static parse(_args) {
        return new EndCommand();
    }
}
exports.EndCommand = EndCommand;
